import React from 'react';
import { motion } from 'framer-motion';
import { CloudRain, BatteryWarning, BrainCircuit } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-navy-950 relative" data-id="element-142">
      <div className="max-w-4xl mx-auto" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-145">
            El Problema de Vivir Sin Filtros
          </h2>
          <div className="w-16 h-1 bg-gold-500 mx-auto mb-8" data-id="element-146" />
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed font-light" data-id="element-147">
            Vivir como una persona sensible en un mundo ruidoso y tóxico se
            siente como caminar bajo la lluvia sin paraguas.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-148">
          {[{
          icon: <CloudRain className="w-8 h-8 text-gold-400" data-id="element-149" />,
          text: 'Absorbes el estrés de tu jefe, la ansiedad de tu pareja y la pesadez de las noticias.'
        }, {
          icon: <BatteryWarning className="w-8 h-8 text-gold-400" data-id="element-150" />,
          text: 'Llegas a casa y no tienes energía para jugar con tus hijos o disfrutar de tu tiempo libre.'
        }, {
          icon: <BrainCircuit className="w-8 h-8 text-gold-400" data-id="element-151" />,
          text: "Te sientes 'sucio' por dentro, nublado y emocionalmente inestable porque tu campo energético está lleno de basura que no te pertenece."
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-navy-900 border border-navy-700 p-8 rounded-lg hover:border-gold-500/30 transition-colors duration-300" data-id="element-152">
              <div className="bg-navy-800 w-16 h-16 rounded-full flex items-center justify-center mb-6 border border-navy-700" data-id="element-153">
                {item.icon}
              </div>
              <p className="text-gray-300 leading-relaxed" data-id="element-154">{item.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}